export default "__VITE_ASSET__CmSPvSoF__"